import { REPORT_MASTER_REQUEST_FAILURE, REPORT_MASTER_REQUEST_SUCCESS, GET_REPORT_MASTER, CREATE_REPORT_MASTER, UPDATE_REPORT_MASTER, DELETE_REPORT_MASTER } from '../types';

const initialState = { 
    reportMaster: [],
    loading: false,
    error: null,
}

const reportMasterReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORT_MASTER_REQUEST_FAILURE: {
            return {
                ...state,
                loading: true,
                error: null
            }
        }
        case GET_REPORT_MASTER: {
            return {
                ...state,
                reportMaster: [ ...action.payload || []],
                loading: false,
                error: null
            }
        }
        case CREATE_REPORT_MASTER: {
            return {
                ...state,
                reportMaster: [action.payload, ...state.reportMaster],
                loading: false,
                error: null
            }
        }
        case UPDATE_REPORT_MASTER: {
            const reportMasterData = state.reportMaster.slice(0);
            const uIndex = reportMasterData.findIndex((data) => data.id === action.payload.id);
            reportMasterData.splice(uIndex, 1, { ...action.payload.data });
            return {
                ...state,
                reportMaster: [ ...reportMasterData ],
                loading: false,
                error: null
            }
        }
        case DELETE_REPORT_MASTER: {
            const reportMaster = state.reportMaster?.slice(0);
            const index = reportMaster.findIndex((data) => data.id === action.id);
            if(index > -1) {
                reportMaster.splice(index, 1);
            }
            return {
                ...state,
                reportMaster: [...reportMaster],
                loading: false,
                error: null
            }
        }
        case REPORT_MASTER_REQUEST_SUCCESS: {
            return {
                ...state,
                loading: false,
                error: null
            }
        }
        default:
            return state;
    }
};

export default reportMasterReducer;